module.exports = __webpack_public_path__ + "media/images/common/logo_horizontal-16faf050f6d8a4cea28ee65beefca2b7.png";